import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Changelog20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6 2.24994C4.48122 2.24994 3.25 3.48116 3.25 4.99994V11.1893L1.53039 9.46967L0.469727 10.5303L4.00006 14.0607L7.53039 10.5303L6.46973 9.46967L4.75 11.1894V4.99994C4.75 4.30958 5.30964 3.74994 6 3.74994H8V2.24994H6Z'
      fill='currentColor'
    />
    <path d='M10 3.75H20V2.25H10V3.75Z' fill='currentColor' />
    <path d='M10 10.75H20V9.25H10V10.75Z' fill='currentColor' />
    <path d='M20 17.75H10V16.25H20V17.75Z' fill='currentColor' />
    <path d='M2 17.75H6V16.25H2V17.75Z' fill='currentColor' />
  </Svg>
);

Changelog20.displayName = 'Changelog20';
export default Changelog20;
